module.exports = __webpack_public_path__ + "img/coke-zero_4.af6ca027.jpg";